// src/components/StructureCards.jsx
import React from 'react';
import { UserCheck, Handshake, Users } from 'lucide-react';

const items = [
  {
    icon: <UserCheck className="w-12 h-12 text-elion-gold" />,
    title: 'Corretor Elion',
    commission: '100% sobre seus imóveis',
    description:
      'Cadastre imóveis, compartilhe com parceiros e tenha seu site exclusivo.',
  },
  {
    icon: <Handshake className="w-12 h-12 text-elion-gold" />,
    title: 'Sócios',
    commission: '80% ao vender imóveis de sócios',
    description:
      'Parcerias registradas com acesso mútuo ao estoque e mais oportunidades.',
  },
  {
    icon: <Users className="w-12 h-12 text-elion-gold" />,
    title: 'Conexões',
    commission: '50% ao vender imóveis da rede',
    description:
      'Networking com profissionais para expandir seu alcance e gerar vendas.',
  },
];

const StructureCards = () => {
  return (
    <section className="bg-elion-navy py-16">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((item, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center bg-[#0e1a2b] rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300"
          >
            {/* Ilustração */}
            <div className="mb-4">{item.icon}</div>

            {/* Título */}
            <h3 className="text-lg font-bold text-white mb-1 text-center">
              {item.title}
            </h3>

            {/* Comissão */}
            <p className="text-sm text-elion-gold font-semibold mb-3 text-center">
              💰 {item.commission}
            </p>

            {/* Descrição */}
            <p className="text-sm text-gray-300 text-center">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StructureCards;
